<template>
<CRow>
    <CCol col="12">
        <ValidationObserver tag="div" class="col" ref="form" v-slot="{ handleSubmit, invalid }">
            <CForm method="post" @submit.prevent="handleSubmit(submitForm)">
                <span class="badge badge-danger p-2 w-100 mb-2">{{ errMessage }}</span>
                <span class="badge badge-success p-2 w-100 mb-2">{{ successMessage }}</span>
                <CRow>
                    <CCustomInput
                        v-if="commission.name !== 'default' || (commission.name === 'default' && excludedNames.includes('default'))"
                        v-model="commission.name"
                        :name="$t('commission.name')"
                        col="12"
                        required
                        :rules="{required: true, excluded: excludedNames}"
                        vid="name"
                        ltr
                        :description="$t('commission.name_rule')"
                    />

                    <CCustomInput
                        v-if="commission.name !== 'default' || (commission.name === 'default' && excludedNames.includes('default'))"
                        v-model="commission.display_name"
                        :name="$t('commission.display_name')"
                        col="12"
                        required
                        rules="required"
                        vid="display_name"
                    />

                    <CCustomInput
                        v-model="commission.benefit"
                        :name="$t('commission._')+'('+$t('percent')+')'"
                        col="12" md="6"
                        required
                        rules="required|max_value:100|min_value:0"
                        vid="benefit"
                        ltr
                    />

                    <CCustomInput
                        v-model="commission.limit"
                        :name="$t('commission.limit')"
                        col="12" md="6"
                        vid="limit"
                        rules="numeric"
                        ltr
                    />
                </CRow>

                <CButton :disabled="invalid" type="submit" color="primary" class="px-4">{{ $t('submit') }}</CButton>
            </CForm>
        </ValidationObserver>
    </CCol>
</CRow>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'SetupCommissionForm',

    props: {
        commission: {
            required: true,
        },
        submit: {
            default: function () {},
            type: Function
        },
        excludedNames: {
            default: function() {return ['click']},
            type: Array
        }
    },

    watch: {
        'commission.limit': function(newVal) {
            this.commission.unlimited = newVal ? false : true
        }
    },

    data() {
        return {
            errMessage: '',
            successMessage: '',
        }
    },

    computed: {
        ...mapGetters('commission', [
            'commissions'
        ])
    },

    methods: {
        submitForm() {
            this.errMessage = ''
            this.submit()
        }
    }
}
</script>